import React, { useEffect, useState } from 'react';
import { normalizeVideoAssetId, isValidVideoAssetId, VIDEO_ASSET_STATUSES } from '../utils/byteplusVideoAsset';

// Optional BytePlus video asset id for the source video (saved on the shot, reused on every edit).
export const VideoAssetIdField = ({ record, onSave, disabled }) => {
    const [value, setValue] = useState(record?.assetId || '');
    const [status, setStatus] = useState(record?.status || 'active');
    useEffect(() => { setValue(record?.assetId || ''); setStatus(record?.status || 'active'); }, [record?.assetId, record?.status]);

    const normalized = normalizeVideoAssetId(value);
    const invalid = normalized.length > 0 && !isValidVideoAssetId(normalized);
    const commit = (nextValue = value, nextStatus = status) => {
        const id = normalizeVideoAssetId(nextValue);
        if (id && !isValidVideoAssetId(id)) return;
        if (id !== value) setValue(id);
        onSave(id ? { assetId: id, status: nextStatus } : null);
    };

    return (
        <div className="col-span-2" data-testid="byteplus-video-asset-field">
            <label className="text-[11px] font-medium text-gray-400">BytePlus video asset ID <span className="text-gray-600">(optional)</span></label>
            <div className="flex gap-1.5 mt-1">
                <input type="text" value={value} onChange={e => setValue(e.target.value)} onBlur={() => commit()} disabled={disabled}
                    placeholder="asset-20261021xxxxxx-abcde"
                    className={`flex-1 min-w-0 p-2 bg-gray-800 border rounded-lg text-xs text-gray-200 focus:outline-none ${invalid ? 'border-red-500' : 'border-gray-700 focus:border-purple-500'}`}
                    data-testid="byteplus-video-asset-id-input" />
                <select value={status} onChange={e => { setStatus(e.target.value); commit(value, e.target.value); }} disabled={disabled || !normalized}
                    className="w-24 p-2 bg-gray-800 border border-gray-700 rounded-lg text-xs text-gray-200" data-testid="byteplus-video-asset-status-select">
                    {VIDEO_ASSET_STATUSES.map(s => <option key={s} value={s}>{s[0].toUpperCase() + s.slice(1)}</option>)}
                </select>
            </div>
            {invalid
                ? <p className="text-[10px] text-red-400 mt-1" data-testid="byteplus-video-asset-error">Must look like asset-xxxx (letters, numbers, dashes).</p>
                : <p className="text-[10px] text-gray-500 mt-1">Used by Seedance for videos with real people. Sent only when Active.</p>}
        </div>
    );
};
